import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayError from 'shared/utils/displayError'

interface removeAllSectionsProps {
  permissionId: number
}

const removeAllSections = async (props: removeAllSectionsProps) => {

  const formData = {
    permission_id: props.permissionId
  }

  const catchFunc = (err: AxiosError) => {
      displayError({errorMessage: err.message ?? 'An error occurred'})
  }

  const response = await axiosPost(apiUrls.permissionsToSections + '/' + apiUrls.actionRemoveAll, formData, catchFunc);

  return response.data === true
}

export default removeAllSections
